// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__lFAu-","spinner":"Spinner_spinner__gdJZR","spinner-aib1d7":"Spinner_spinner-aib1d7__mNZ-B"};